import React, { useState, useRef } from "react";
import {
  Typography,
  Box,
  Collapse,
  Divider,
  List,
  ListItemButton,
} from "@mui/material";
import { productDataList } from "../data/productListData";
import IconButton from "@mui/material/IconButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClearIcon from "@mui/icons-material/Clear";
import Product from "./Product";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

const ToggleDrawer = ({
  handleDrawerToggle,
  mobileOpen,
  onAboutClick,
  onInstClick,
  ontestimonialClick,
  onCompareProClick,
  onQARefClick,
  onContactRefClick,
}) => {
  const [expanded, setExpanded] = useState(null);
  // Handle mouse enter event on the Products button
  const handleToggle = (index) => {
    setExpanded(expanded === index ? null : index); // Toggle between expanded and collapsed
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2, // Padding for spacing
          borderBottom: "1px solid #ddd", // Optional, adds a subtle border
        }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src={logo}
            alt="Logo"
            style={{
              height: 40, // or whatever height suits your design
              cursor: "pointer",
            }}
          />
        </Link>
        <IconButton
          sx={{ color: "primary.main", background: "#f4f4f4" }}
          onClick={handleDrawerToggle}
        >
          <ClearIcon />
        </IconButton>
      </Box>
      <Divider />
      <List>
        <ListItemButton
          onClick={() => {
            onAboutClick(); // scrolls to the ref
            handleDrawerToggle(); // closes the drawer
          }}
        >
          <Typography variant="body1">About the Course</Typography>
        </ListItemButton>
        <Divider />
        <ListItemButton
          component={Link}
          //to="/about"
          onClick={handleDrawerToggle}
        >
          <Typography variant="body1">Enroll</Typography>
        </ListItemButton>
        <Divider />
        <ListItemButton
          onClick={() => {
            onInstClick();
            handleDrawerToggle();
          }}
        >
          <Typography variant="body1">Instructor</Typography>
        </ListItemButton>
        <Divider />
        <ListItemButton
          onClick={() => {
            ontestimonialClick();
            handleDrawerToggle();
          }}
        >
          <Typography variant="body1">Testimonials</Typography>
        </ListItemButton>

        <Divider />
        <ListItemButton
          onClick={() => {
            onCompareProClick();
            handleDrawerToggle();
          }}
        >
          <Typography variant="body1">Compare Progams</Typography>
        </ListItemButton>
        <Divider />
        <ListItemButton
          onClick={() => {
            onQARefClick();
            handleDrawerToggle();
          }}
        >
          <Typography variant="body1">Q&A</Typography>
        </ListItemButton>
        <Divider />
        <ListItemButton
          onClick={() => {
            onContactRefClick();
            handleDrawerToggle();
          }}
        >
          <Typography variant="body1">Contact</Typography>
        </ListItemButton>
      </List>
    </Box>
  );
};

export default ToggleDrawer;
